import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { api } from '../api';
import { useAuth } from '../context/AuthContext';

const TAB_PARAMS = {
  assigned: { assigned_to: 'me' },
  created: { created_by: 'me' },
  archived: { mine: 'true', archived: 'true' },
  all: { all: 'true' },
};

const EMPTY_MESSAGES = {
  assigned: "No tasks assigned to you. You're all caught up.",
  created: "You haven't created any tasks yet.",
  archived: 'No archived tasks yet.',
  all: 'No open or completed tasks right now.',
};

export default function TaskList() {
  const { user } = useAuth();
  const [tab, setTab] = useState('assigned');
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .listTasks(TAB_PARAMS[tab])
      .then(setTasks)
      .catch(() => toast.error("Couldn't load tasks."))
      .finally(() => setLoading(false));
  }, [tab]);

  return (
    <div className="page">
      <div className="tabs">
        <button className={tab === 'assigned' ? 'tab active' : 'tab'} onClick={() => setTab('assigned')}>
          Assigned to me
        </button>
        <button className={tab === 'created' ? 'tab active' : 'tab'} onClick={() => setTab('created')}>
          Created by me
        </button>
        <button className={tab === 'archived' ? 'tab active' : 'tab'} onClick={() => setTab('archived')}>
          Archived
        </button>
        {user?.role === 'admin' && (
          <button className={tab === 'all' ? 'tab active' : 'tab'} onClick={() => setTab('all')}>
            All tasks
          </button>
        )}
      </div>

      {loading && <p className="hint">Loading…</p>}

      {!loading && tasks.length === 0 && <p className="hint">{EMPTY_MESSAGES[tab]}</p>}

      <ul className="task-list">
        {tasks.map((task) => (
          <li key={task.id}>
            <Link to={`/tasks/${task.id}`} className="task-row">
              <div>
                <div className="task-title">{task.title}</div>
                {tab === 'all' ? (
                  <div className="task-desc">Assigned to {task.assigned_to_name || 'unknown'}</div>
                ) : (
                  task.description && <div className="task-desc">{task.description}</div>
                )}
              </div>
              <span className={`badge ${task.status}`}>{task.status}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
